/* ============================================================
   HOLY SPIRIT — Predictive Search enhancer (SAFE, additive)
   Adds Popular Searches, Recent Searches (localStorage) and a
   "View All Products" link to Horizon's NATIVE predictive search.

   Design rules (to never freeze the Theme Editor):
     - NO MutationObserver.
     - NO polling / no timers-in-loops / no recursion.
     - ONE-TIME DOM injection, guarded by a flag.
     - Event-delegated listeners only (click / submit / keydown / focusin).
     - The injected block is a SIBLING of the morphed results container,
       so Shopify's morph() never touches it -- no re-render needed.
     - Everything wrapped in try/catch: if this fails, the native
       search drawer still opens and works normally.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'hs_recent_searches';
  var MAX = 6;
  var POP = ['Necklaces', 'Rings', 'Earrings', 'Bracelets', 'Gold', 'Pearl Jewelry'];
  var ALL_URL = '/collections/all';

  var CLOCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var XICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
    '<path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(a) {
    try {
      localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX)));
    } catch (e) {}
  }
  function add(term) {
    term = (term || '').trim();
    if (!term) return;
    var a = read().filter(function (t) {
      return t.toLowerCase() !== term.toLowerCase();
    });
    a.unshift(term);
    write(a);
  }
  function removeTerm(term) {
    write(
      read().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      })
    );
  }
  function clearAll() {
    write([]);
  }
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  function searchUrl(t) {
    var base = (window.Theme && Theme.routes && Theme.routes.search_url) || '/search';
    return base + '?q=' + encodeURIComponent(t);
  }

  var POPULAR_HTML =
    '<div class="hs-x__section hs-x__popular">' +
    '<span class="hs-x__label">Popular Searches</span>' +
    '<div class="hs-x__chips">' +
    POP.map(function (t) {
      return '<a class="hs-x__chip" href="' + searchUrl(t) + '" data-hs-term="' + esc(t) + '">' + esc(t) + '</a>';
    }).join('') +
    '</div></div>';

  var RECENT_HTML =
    '<div class="hs-x__section hs-x__recent" data-hs-recent-wrap hidden>' +
    '<div class="hs-x__head">' +
    '<span class="hs-x__label">Recent Searches</span>' +
    '<button type="button" class="hs-x__clear" data-hs-clear>Clear all</button>' +
    '</div>' +
    '<div class="hs-x__recent-list" data-hs-recent></div></div>';

  /* Render the recent-searches list inside a component's persistent block. */
  function render(comp) {
    try {
      var list = comp.querySelector('[data-hs-recent]');
      var wrap = comp.querySelector('[data-hs-recent-wrap]');
      if (!list || !wrap) return;
      var items = read();
      if (!items.length) {
        wrap.setAttribute('hidden', '');
        list.innerHTML = '';
        return;
      }
      wrap.removeAttribute('hidden');
      list.innerHTML = items
        .map(function (t) {
          var e = esc(t);
          return (
            '<a class="hs-x__recent-item" href="' + searchUrl(t) + '" data-hs-term="' + e + '">' +
            '<span class="hs-x__recent-clock">' + CLOCK + '</span>' +
            '<span class="hs-x__recent-txt">' + e + '</span>' +
            '<button type="button" class="hs-x__recent-rm" data-hs-remove="' + e + '" aria-label="Remove recent search">' +
            XICON + '</button>' +
            '</a>'
          );
        })
        .join('');
    } catch (e) {}
  }

  /* Inject the extras block ONCE per component (guarded). */
  function injectExtras(comp) {
    try {
      if (comp.__hsExtras) return;
      var wrap = comp.querySelector('.predictive-search-form__content-wrapper');
      var content = comp.querySelector('.predictive-search-form__content');
      if (!wrap || !content) return;
      comp.__hsExtras = true;

      var top = document.createElement('div');
      top.className = 'hs-x hs-x--top';
      top.setAttribute('data-hs-extras', '');
      top.innerHTML = POPULAR_HTML + RECENT_HTML;
      wrap.insertBefore(top, content);

      var va = document.createElement('a');
      va.className = 'hs-x hs-x--viewall';
      va.setAttribute('data-hs-extras', '');
      va.href = ALL_URL;
      va.textContent = 'View All Products';
      if (content.nextSibling) wrap.insertBefore(va, content.nextSibling);
      else wrap.appendChild(va);

      render(comp);
    } catch (e) {}
  }

  function scan() {
    var comps = document.querySelectorAll('predictive-search-component');
    for (var i = 0; i < comps.length; i++) {
      injectExtras(comps[i]);
    }
  }
  function renderAll() {
    var comps = document.querySelectorAll('predictive-search-component');
    for (var i = 0; i < comps.length; i++) render(comps[i]);
  }

  /* Fire the native predictive search for a term by writing to the input
     and dispatching the same InputEvent the component listens for. */
  function triggerFromChip(el, term) {
    var form = el.closest('.predictive-search-form');
    var input = form && form.querySelector('input.search-input, input[type="search"]');
    if (!input) return false;
    add(term);
    renderAll();
    input.value = term;
    input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }));
    input.focus();
    return true;
  }

  /* ---- ONE delegated click listener ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var rm = t.closest('[data-hs-remove]');
    if (rm) {
      e.preventDefault();
      e.stopPropagation();
      removeTerm(rm.getAttribute('data-hs-remove'));
      renderAll();
      return;
    }
    var clr = t.closest('[data-hs-clear]');
    if (clr) {
      e.preventDefault();
      e.stopPropagation();
      clearAll();
      renderAll();
      return;
    }
    var chip = t.closest('[data-hs-term]');
    if (chip) {
      var term = chip.getAttribute('data-hs-term');
      /* If we can trigger the native search, do so; otherwise let the href navigate. */
      if (triggerFromChip(chip, term)) e.preventDefault();
      return;
    }
  });

  /* Save the typed term when a search is actually submitted. */
  document.addEventListener(
    'submit',
    function (e) {
      try {
        var form = e.target && e.target.closest && e.target.closest('.predictive-search-form');
        if (!form) return;
        var input = form.querySelector('input.search-input');
        if (input && input.value.trim()) add(input.value.trim());
      } catch (err) {}
    },
    true
  );
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest && e.target.closest('input.search-input');
    if (input && input.value.trim()) add(input.value.trim());
  });

  /* Inject + refresh when the user focuses into the search field
     (fires on modal open and whenever they return to the input). */
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('predictive-search-component')) {
      scan();
      renderAll();
    }
  });

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
